import axios from 'axios';
import React, { useState } from 'react'
import { useEffect } from 'react';

export const useConsultarIp = () => {

    const [ip, setip] = useState('')

    const getData = async () => {
        try {
  
            const response = await axios.get(`https://api.ipify.org`);
                    
            // console.log(response.data)
              
            setip(response.data)
  
  
  
            } catch (error) {
              
            console.log(error)
            setip('')
                
            }
  
  
      }


      useEffect(() => {
        getData()
      }, [])
      


  return {
    ip
  }
}
